import { render, staticRenderFns } from "./OpenMarketDetail.vue?vue&type=template&id=7550265e&scoped=true&"
import script from "./OpenMarketDetail.vue?vue&type=script&lang=js&"
export * from "./OpenMarketDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7550265e",
  null
  
)

export default component.exports